import {
  backgroundCss,
  borderCss,
  boxShadowCss,
  mobileBackgroundCss,
  mobileBorderCss,
  mobileBoxShadowCss,
  mobilePaddingsCss,
  paddingsCss,
} from 'common/utils/styleUtilsNew'
import { css, styled } from 'styled-components'
import {
  BorderType,
  ContentWidthEnum,
  PaddingType,
} from 'common/types/styleTypes'
import { contentWidthValues } from 'src/shared/constants/content-width-values'

export interface WebsiteFooterWrapperProps {
  border: Partial<BorderType>
  mobileBorder: Partial<BorderType>
  padding: Partial<PaddingType>
  mobilePadding: Partial<PaddingType>
  contentWidth?: ContentWidthEnum
  boxShadow?: string | undefined
  mobileBoxShadow?: string
}

export const WebsiteFooterWrapper = styled.footer<WebsiteFooterWrapperProps>`
  ${p =>
    p?.contentWidth &&
    css`
      max-width: ${contentWidthValues[p?.contentWidth]};
      margin: 0 auto;
      `};
    ${paddingsCss}
    ${borderCss}
    ${boxShadowCss}


  ${p => p.theme.phone} {
    
    ${mobilePaddingsCss}
    ${mobileBorderCss}
    ${mobileBoxShadowCss}
  }



  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobilePaddingsCss}
      ${mobileBorderCss}
      ${mobileBoxShadowCss}
    `}

`
